import styled from "styled-components";
import { palette, size } from "styled-theme";

export const LabelTypography = styled.label`
    color: ${palette("formInputElement", 0)};
    font-weight: 400;
    font-size: ${size("p0")};

    &.error {
      color: ${palette("error", 4)};
      font-weight: bold;
    }
`;

const Wrapper = styled.div`
  .select-Component {
    margin: 10px 0px;
    min-height: 80px;
    position: relative;
  }

  .select-Component.padded {
    margin: 0;
    padding: 10px 0px;
  }
  .select-Label {
    display: flex;
    padding-left: 3px;
    padding-bottom: 7px;
  }
  .select-Select {
    display: flex;
    border: 1px solid ${palette("formInputElement", 1)};
    border-radius: 5px;
    margin: 0 !important;
    padding-left: 7px;
    padding-right: 2px;
    overflow: hidden;
    height: 38px;
    width: 100%;
    color: ${palette("formInputElement", 0)};
    fill: ${palette("color", 14)};
    background-color: ${palette("formInputElement", 5)};
  }
  .select-Select * {
    border: none;
    font-size: ${size("p0")};
  }
  .select-Select:focus-within {
    outline: none;
  }

  .select-loader {
    display: flex;
    position: absolute;
    width: 100%;
    height: 38px;
    background-color: ${palette("border", 3)};
    opacity: 0.5;
    border-radius: 5px;
    justify-content: center;
    align-items: center;
    user-select: none;
  }
  svg:not(:root).svg-inline--fa {
    overflow: visible;
  }
  .svg-inline--fa.fa-w-16 {
    width: 2em;
  }
  .svg-inline--fa {
    display: inline-block;
    font-size: inherit;
    height: 1em;
    overflow: visible;
    vertical-align: -0.125em;
  }
  .select-spinner-icon {
    display: block;
    height: inherit;
    -webkit-animation: spin 4s linear infinite;
    -moz-animation: spin 4s linear infinite;
    animation: spin 4s linear infinite;
    color: ${palette("color", 16)};
  }
  .textBox-Label-Optional {
    padding-left: 6px;
    font-size: ${size("p3")};
    color: ${palette("grayscale", 15)};
    font-weight: 700;
  }
  .required:focus-within {
    box-shadow: 0 0 6px ${palette("color", 18)};
    outline: none;
  }
  .select-Select:focus-within:not(.required) {
    box-shadow: 0 0 6px ${palette("input", 0)};
  }
  .required {
    border: 2px solid ${palette("error", 4)}!important;
  }
  @-moz-keyframes spin {
    100% {
      -moz-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
  @keyframes spin {
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`;

export default Wrapper;
